import { isDefined } from "./array.utils";

export * from "./array.utils";
export * from "./dates";
export * from "./debugMode";
export * from "./formatter.utils";
export * from "./hooks";
export * from "./object.utils";
export * from "./option.utils";
export * from "./phoneMask.utils";
export * from "./plan.utils";
export * from "./queryResult";
export * from "./sb";
export * from "./string.utils";
export * from "./tests/utils";
export * from "./types.utils";
type ErrorClass<T extends Error> = {
  new (...args: any[]): T;
};

export function fail(): never;
export function fail(message: string): never;
export function fail(error: Error): never;
export function fail<T extends Error>(errorClass: ErrorClass<T>, ...args: any[]): never;
export function fail<T extends Error>(messageOrErrorOrClass?: string | Error | ErrorClass<T>, ...args: any[]): never {
  if (!isDefined(messageOrErrorOrClass)) {
    throw new Error("Failed");
  } else if (typeof messageOrErrorOrClass === "string") {
    throw new Error(messageOrErrorOrClass);
  } else if (messageOrErrorOrClass instanceof Error) {
    throw messageOrErrorOrClass;
  } else {
    args = args.length === 0 ? ["Failed"] : args;
    throw new messageOrErrorOrClass(...args);
  }
}
